export default __webpack_public_path__ + "static/media/No.8-2.c0878be6.jpg";